import { forwardRef, HtmlHTMLAttributes, ReactNode } from "react";
import classNames from "classnames";

import { ReactComponent as MoreItemsIcon } from "./icons/more-items-icon.svg";

import styles from "./style.module.scss";

export type MoreItemsButtonProps = HtmlHTMLAttributes<HTMLButtonElement> & {
  icon?: ReactNode
};

export const MoreItemsButton = forwardRef<HTMLButtonElement, MoreItemsButtonProps>(
  (
    {
      children,
      className,
      icon,
      ...props
    }, ref) => {
    return (
      <button
        type="button"
        className={classNames(className, styles.root)}
        ref={ref}
        {...props}
      >
        {icon ? icon : <MoreItemsIcon />}
      </button>
    );
  });

export default MoreItemsButton;
